import noResult from './noResult'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const infiniteHits = (itemComponent, button) => {
  return (renderOptions, isFirstRender) => {
    const { hits, sendEvent, widgetParams, showMore, isLastPage } = renderOptions

    if (isFirstRender) {
      const grid = document.createElement('div')
      grid.className = 'grid'

      const nextButton = document.createElement('button')
      nextButton.className =
          'infinite-hits__next vn-btn'
      nextButton.textContent = button.textContent

      const fakeButton = document.createElement('div')
      fakeButton.className = 'vn-btn vn-btn--transparent'
      fakeButton.textContent = button.buttonContent

      nextButton.addEventListener('click', () => {
        showMore()
      })

      nextButton.appendChild(fakeButton)
      widgetParams.container.appendChild(grid)
      widgetParams.container.appendChild(nextButton)

      return
    }

    widgetParams.container.querySelector('.infinite-hits__next').disabled =
      isLastPage

    widgetParams.container.querySelector('.grid').innerHTML = `
      ${
        hits.length
          ? hits
              .map((item) => {
                return itemComponent(item, 'g-col-12 g-col-md-6 g-col-lg-4')
              })
              .join('')
          : noResult
      }
  `
    widgetParams.container.querySelectorAll('.feed-product__wrapper').forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'Product clicked');
      });
    });

    widgetParams.container.querySelectorAll('.feed-boat__wrapper').forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'Boat clicked');
      });
    });
  }
}

export default infiniteHits
